class model_class {
  dispatch = null;
  get_dispatch = () => (this.dispatch == null ? false : this.dispatch);
  set_dispatch = (n_dispatch) => {
    this.dispatch = n_dispatch;
  };

  setData = (label, payload) => {
    this.dispatch({ type: "SET_STORE", label, payload });
  };

  updateInfoUser = (payload) => {
    this.dispatch({ type: "UPDATE_INFO_USER", payload });
  };

  resetData = () => {
    this.dispatch({ type: "RESET_DATA" });
  };

  updateAlerts = (payload) => {
    this.dispatch({ type: "UPDATE_ALERT", payload });
  };

  logMetaEvent = (data) => {
    if (
      !(
        process.env.NODE_ENV === "development" ||
        window?.location?.host?.includes?.("test.")
      )
    ) {
      fetch(
        `https://graph.facebook.com/v23.0/1267745984869632/events?access_token=EAAO1ZAbs13LoBOymAZAMLSGFWE8OQlInhCm8Kbubs6JVbOi5kZAPdZBxDbhOpkhtrQX9DDcIcSMBuwBPD36HQyE1rO1mE0i0eZCzQkzLnirxHAKTXVYp8q1F4FwzhaY55VchcyG68KV0pXNsotqirIchuOcRrl4uLdf53H0riyZCXTSo6FKUQoBTAUShkANThZADAZDZD`,
        {
          body: JSON.stringify(data),
          method: "POST",
          headers: {
            "content-type": "application/json",
          },
        }
      );
    }
  };
}

const Model = new model_class();

export default Model;
